// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import axios from 'axios'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import Vue2OrgTree from 'vue2-org-tree'
import moment from "moment"
Vue.use(Vue2OrgTree)
Vue.use(ElementUI)
Vue.config.productionTip = false
import '@/global/index.js'
import '@/assets/css/icon.css'
import '@/assets/css/main.css'
import '@/assets/css/color-light.css'
import '@/components/common/directives'
import 'babel-polyfill'
import store from './store/index'
import * as echarts from 'echarts'
import 'echarts-extension-amap'
import 'echarts-gl'
import 'echarts-wordcloud'
import { POST, GET } from './request/http'
// import * as API from '@/request/api.js'
import API from '@/api/index'
import '@/request/webscoket.js'

import * as COOKIE from '@/assets/js/cookie.js'
// import * as UTILS from '@/utils/utils.js'
import UTILS from '@/utils/index.js'
import BUS from '@/assets/js/bus.js'
import Constant from '@/assets/js/constant.js' //vue剪切板
import VueClipboard from 'vue-clipboard2'
import dataV from '@jiaminghi/data-view'
import CollegeSystem from '@/assets/js/collegeSystem/CollegeSystem'
import Quill from 'quill'
import imageResize from 'quill-image-resize'
window.Quill = Quill
Quill.register('modules/imageResize', imageResize)
Vue.use(dataV)

Vue.use(VueClipboard)

// import 'lib-flexible'//阿里弹性布局方案
// import Print from 'vue-print-nb'
Vue.prototype.$store = store
Vue.prototype.$post = POST
Vue.prototype.$get = GET
Vue.prototype.$echarts = echarts
Vue.prototype.$API = API
Vue.prototype.$cookie = COOKIE
Vue.prototype.$BUS = BUS
Vue.prototype.$UTILS = UTILS
Vue.prototype.$constant = new Constant()
Vue.prototype.$CS = CollegeSystem
Vue.prototype.$moment = moment;

//axios ---------------------------------------------------------------
Vue.prototype.$axios = axios // 将axios配置成vue的原型

// 注册全局组件
const requireComponent = require.context(
  // 其组件目录的相对路径
  './components/parts',
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /[\w-]+\.vue$/
)

requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)

  // 剥去文件名开头的 `./` 和结尾的扩展名
  // const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  const componentName = fileName.substring(fileName.lastIndexOf('/')).replace(/^\/(.*)\.\w+$/, '$1')

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  )
})
//禁用浏览器的返回
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL)
})

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  let username = COOKIE.getCookie('username')
  let token = COOKIE.getCookie('token')

  // const role = localStorage.getItem('hb_username');
  if (
    (!username || !token) &&
    to.path !== '/login' &&
    to.path !== '/overview/dorm' &&
    to.path !== '/overview/enter' &&
    to.path !== '/overview/enter2' &&
    to.path !== '/overview/enter2022' &&
    to.path !== '/dorm/editPlan' &&
    to.path !== '/dorm/transfer' &&
    to.path !== '/dorm/show' &&
    to.path !== '/dorm/dormManagementShow' &&
    to.path !== '/activity/dumpling-ticket' &&
    to.path !== '/welcomeNewStudent/monitor-screen' &&
    to.path !== '/overview/welcome-old-student2022' &&
    to.path !== '/overview/welcome-new-student2022' &&
    to.path !== '/overview/welcome-all-student2022' &&
    to.path !== '/overview/welcome-student' &&
    to.path !== '/overview/enter2022-spring' &&
    to.path !== '/welcomeNewStudent/plant/data-analyse'
  ) {
    store.commit('system/SET_LAST_VISIT_ROUTE', to.fullPath)
    next('/login')
  } else if (to.meta.permission) {
    console.log('跳转')
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    role === 'admin' ? next() : next('/403')
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
      Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
        confirmButtonText: '确定'
      })
    } else {
      next()
    }
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js